import Button from './ui/Button';
import { trackSignupClick } from '../utils/analytics';

export default function Hero() {
  return (
    <section className="relative flex items-center justify-center px-6 py-20 overflow-hidden">
      {/* Vibrant gradient background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-accent-light via-bg to-secondary-light opacity-40" />
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-accent/20 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-secondary/20 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto text-center">
        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-heading font-bold mb-6 leading-tight text-fg">
          Stop Guessing.
          <br />
          <span
            style={{
              background: 'linear-gradient(90deg, #06b6d4 0%, #10b981 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              MozBackgroundClip: 'text',
              MozTextFillColor: 'transparent',
              display: 'inline-block',
            }}
          >
            Start Chipping Away.
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-muted mb-12 max-w-2xl mx-auto leading-relaxed">
          Build a debt payoff plan that{' '}
          <span className="text-fg font-semibold">flexes with your income</span>. Know{' '}
          <span className="text-fg font-semibold">exactly what to pay, when to pay it</span>, and
          when you'll be <span className="text-fg font-semibold">debt-free</span>.
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <a href="https://app.debtchisel.com/register" onClick={() => trackSignupClick('free', 'monthly')}>
            <Button size="lg">Get Started Free</Button>
          </a>
          <a
            href="https://app.debtchisel.com/login"
            className="text-sm text-accent hover:underline"
          >
            Already have an account? Log in
          </a>
        </div>

        {/* Key benefits with color */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 rounded-full">
            <svg
              className="w-4 h-4 text-success"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-success font-medium">Free up to 5 debts</span>
          </div>
          <div className="flex items-center gap-2 px-3 py-1.5 bg-accent/10 rounded-full">
            <svg
              className="w-4 h-4 text-accent"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-accent font-medium">No credit card required</span>
          </div>
          <div className="flex items-center gap-2 px-3 py-1.5 bg-secondary/10 rounded-full">
            <svg
              className="w-4 h-4 text-secondary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-secondary font-medium">No bank login needed</span>
          </div>
        </div>
      </div>
    </section>
  );
}
